import { Delivery, interpretServerDelivery } from './delivery';
import { Schedule, interpretServerSchedule } from './schedule';

export class Task {
  id?: number;
  name: string;
  pages: string[];
  type: string;
  typeString: string;
  status: 'Active' | 'Inactive' | string;
  nextExecution?: string;
  PBIReportId: string;
  PBIReportName: string;
  PBIWorkspaceId: string;
  PBIWorkspaceName?: string;
  deliveryContacts: Delivery[] = [];
  schedules: Schedule[] = [];
  objects?: TaskObject[] = [];
  flagPdfPassword?: boolean;
  flagImageInBody?: boolean;
}

export class TaskObject {
  name: string;
  type: 'I' | 'D';
  page: string;
  objectId?: string;
  reportOrder:number;
  pageView: '16:9'| 'Letter'| '4:3'|'Custom';
  width?:number;
  height?:number;
}

const serverPropertyLookup = {
  idReport: 'id',
  name: 'name',
  type: 'type',
  status: 'status',
  nextExecution: 'nextExecution',
  PBIReportId: 'PBIReportId',
  PBIWorkspaceId: 'PBIWorkspaceId',
  PBIReportName: 'PBIReportName',
  flagPdfPassword: 'flagPdfPassword',
  flagImageInBody: 'flagImageInBody',
};

export function interpretServerTask(task: any): Task {
  const result = new Task();

  for (let key in serverPropertyLookup) {
    result[serverPropertyLookup[key]] = task[key];
  }

  result.pages = task.pages.split(',');
  result.typeString = getTaskTypeString(result);
  result.deliveryContacts = task.deliveryContacts ? task.deliveryContacts.map(interpretServerDelivery) : [];
  result.schedules = task.schedules ? task.schedules.map(interpretServerSchedule) : [];
  result.objects = task.objects;
  return result;
}

export function convertToServerTask(task: Task): any {
  const result: any = {};

  for (let key in serverPropertyLookup) {
    console.log(key);
    result[key] = task[serverPropertyLookup[key]];
  }

  result.deliveryContacts = task.deliveryContacts || [];

  // Normalize tags into string
  for (let delivery of result.deliveryContacts) {
    if (delivery.tags instanceof Array) {
      if (delivery.tags.length === 0) {
        delivery.tags = "";
      } else if (typeof delivery.tags[0] !== "string") {
        throw new Error("Tags can only be string or array of strings, got " + typeof delivery.tags[0]);
      } else if (delivery.tags.length === 1 && delivery.tags[0] === "") {
        delivery.tags = "";
      } else {
        delivery.tags = delivery.tags.join(" ");
      }
    } else if (!delivery.tags || (typeof delivery.tags === "string" && !delivery.tags.trim())) {
      delivery.tags = '';
    }
  }

  result.schedules = task.schedules || [];
  result.objects = task.objects;
  result.pages = task.objects.map(i=>i.page).join(',');
  delete result.nextExecution;

  return result;
}

export function getTaskTypeString(task: Task) {
  if (task.type === 'PNG') {
    return task.flagImageInBody ? 'image-body' : 'image-attachment';
  }
  return task.flagPdfPassword ? 'encrypted-pdf' : 'unencrypted-pdf';
}
